import { ActionTree } from 'vuex';
import { IRootState } from '../root-state.store';
import { ITicketState } from './ticket-state.store';
import {
  TICKET_GET_TICKETS, TICKET_LOADING,
  TICKET_SET_TICKETS,
  TICKET_SET_TICKETS_SIDEBAR,
  TICKET_GET_TICKETS_SIDEBAR,
  TICKET_GET_TICKET_ACTIONS,
  TICKET_SET_TICKET_ACTIONS,
  TICKET_RECORD,
  TICKET_ACTION_SEND_MESSAGE,
  TICKET_ACTION_UPDATE_MESSAGE,
  TICKET_ACTION_SEND_FILE,
  TICKET_ACTION,
  TICKET_ACTION_LOADING,
  TICKET_INIT,
  TICKET_SET_TICKET_SIDEBAR,
  TICKET_SET_TICKETS_PARAMETER_SIDEBAR,
  TICKET_GET_TICKET,
  TICKET_RECORD_CHANNEL,
  TICKET_SET_TICKETS_PARAMETER,
  TICKET_ACTION_ATTACHMENTS,
  TICKET_CLEAR_ATTACHMENTS,
  TICKET_UPDATE_CURRENT_STATE,
  TICKET_ADD_SINGLE_ITEM,
  TICKET_GET_TICKET_NOTIFICATION,
  TICKET_RECORD_ASK_APPARTMENT,
  TICKET_RESET,
  TICKET_REQUEST_TO_JOIN,
  TICKET_GET_CHARACTER_PROBLEMS,
  TICKET_SET_CHARACTER_PROBLEMS,
  TICKET_GET_CLOSURE_REASON,
  TICKET_GET_CLOSURE_REASON_LOADING,
  TICKET_GET_REASONS,
  TICKET_GET_REASONS_LOADING,
  TICKET_REQUEST_TO_JOIN_CHANNEL,
  TICKET_GET_TICKET_CHANNEL,
  TICKET_SET_TICKET_CHANNEL,
  TICKET_ADD_PARTICIPANTS,
  TICKET_REMOVE_PARTICIPANTS,
  TICKET_GET_CHANNEL,
  TICKET_GET_APPOINTMENTS,
  TICKET_INTERVENTION_REPORT,
  TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS,
  TICKET_ACTION_DELETE_ATTACHMENT,
  TICKET_UPDATE,
  TICKET_EDIT,
  TICKET_SET_EXTERNAL_APARTMENT,
  TICKET_UPDATE_TICKETS,
  TICKET_SET_LOADER_STATE,
  TICKET_LOADERS,
  TICKET_GET_TICKET_PRIORITY_LEVEL,
  TICKET_SET_TICKET_PRIORITY_LEVEL,
  TICKET_GET_TICKET_SUBSTATUS,
  TICKET_SET_TICKET_SUBSTATUS,
  TICKET_GET_TICKET_PROBLEM_TYPE,
  TICKET_SET_TICKET_PROBLEM_TYPE,
  TICKET_GET_EQUIPMENT,
  TICKET_SET_EQUIPMENT
} from './ticket-types.store';
import { ActivityStatus, StateTypes } from '../../common/enums';
import { ITicketParameter, ITicketListingViewModel, ITicketChannel, ITicketInterventionReport } from '../../models/ticket';
import { ITicket } from '../../models/ticket/ticket.model';

export const actions: ActionTree<ITicketState, IRootState> = {
  [TICKET_GET_TICKETS]: async ({ getters, commit, state }, payload: { param?: ITicketParameter, merge?: boolean }) => {

    commit(TICKET_LOADING, ActivityStatus.Loading);

    return getters.service!.getTickets(payload.param ? payload.param : state.ticketParameter, true)
      .then(response => {
        console.log('get tickets response=',response)
        commit(TICKET_SET_TICKETS, {
          activityStatus: ActivityStatus.Loaded,
          tickets: response.data,
          merge: payload.merge,
          pagination: { limit: response.limit, total: response.total, skip: response.skip }
        })

        if (payload.param) {
          commit(TICKET_SET_TICKETS_PARAMETER, payload.param)
        }
        return Promise.resolve(response.data);
      })
      .catch(error => {
        commit(TICKET_LOADING, ActivityStatus.LoadFailed)
        return Promise.reject(error)
      })
  }
  , [TICKET_GET_TICKET]: async ({ getters, commit }, action: { ticketId: number, isTicketModule?: boolean }) => {

    return await getters.service!.getTicket(action.ticketId)
      .then((ticket: ITicket) => {
        if (action.isTicketModule) {
          commit(TICKET_SET_TICKET_SIDEBAR, ticket);
        }
        return ticket;
      })
      .catch(error => {
        console.log(error, 'error');

        return Promise.reject(error);
      })
  }
  , [TICKET_GET_TICKET_NOTIFICATION]: async ({ getters, commit }, ticketId: number) => {

    return await getters.service!.getTicket(ticketId)
      .then((ticket: ITicket) => {
        commit(TICKET_ADD_SINGLE_ITEM, ticket);
        return ticket;
      })
      .catch(error => {
        return error;
      })
  }

  , [TICKET_GET_TICKETS_SIDEBAR]: async ({ getters, state, commit }, payload: { param?: ITicketParameter, ticketId?: number }) => {

    if (payload.param) {
      commit(TICKET_SET_TICKETS_PARAMETER_SIDEBAR, payload.param)
    }
    return getters.service!.getTickets(payload.param ? payload.param : getters.ticketSidebarParameter)
      .then((tickets: ITicketListingViewModel[]) => {
        commit(TICKET_SET_TICKETS_SIDEBAR, { tickets, ticketId: payload.ticketId });
        return Promise.resolve(tickets);
      })
      .catch(error => Promise.reject(error))
  }
  , [TICKET_GET_TICKET_ACTIONS]: async ({ getters, state, commit, rootGetters }, payload: { channelId: number, ticketId: number }) => {
    commit(TICKET_LOADING, ActivityStatus.Loading);
    commit(TICKET_SET_LOADER_STATE,
      { key: [TICKET_LOADERS.CHAT_CONTENT,TICKET_LOADERS.CHAT_EDITOR,TICKET_LOADERS.CHAT_HEADER], value: true })
    await getters.service!.getTicket(payload.ticketId)
      .then((ticket: ITicket) => {
        commit(TICKET_SET_TICKET_SIDEBAR, ticket);
      })
      .catch(error => {
        commit(TICKET_LOADING, ActivityStatus.LoadFailed);
        return Promise.reject(error)
      })

    return getters.service!.getTicketChannelById(payload.channelId, payload.ticketId)
      .then((channel: ITicketChannel) => {
        commit(TICKET_SET_TICKET_ACTIONS, {
          currentChannel: channel,
          activityStatus: ActivityStatus.Loaded,
          currentTicketId: payload.ticketId,
          currentChannelId: payload.channelId,
          ownerId: rootGetters['user/userInfo'].id
        });
        return Promise.resolve(channel);
      })
      .catch(error => {
        commit(TICKET_LOADING, ActivityStatus.LoadFailed);
        return Promise.reject(error);
      })
      .finally(()=>{
        commit(TICKET_SET_LOADER_STATE,{ key:
          [TICKET_LOADERS.CHAT_CONTENT, TICKET_LOADERS.CHAT_EDITOR,TICKET_LOADERS.CHAT_HEADER], value: false })
      })
  }
  , [TICKET_RECORD]: async ({ commit, getters, state, rootGetters }, payload: { attachments?: any, keepAlive: boolean }) => {
    commit(TICKET_SET_EXTERNAL_APARTMENT,rootGetters['user/modules']['ticket_create']) // old = ticket_external_apartment
    return getters.service.recordTicket(getters.ticket,
      rootGetters['user/userInfo'].agencies[0].fk_entity_primary)
      .then((createdTicket: ITicket) => {
        commit(TICKET_ACTION_ATTACHMENTS, payload.attachments);
        if (!payload.keepAlive) {
          commit(TICKET_INIT, state.service.initTicket());
        } else {
          commit(TICKET_INIT, Object.assign({}, state.service.initTicket(), {
            //creator: getters.ticket.creator,
            declarant: getters.ticket.declarant,
            mandates: getters.ticket.mandates,
            quotes: getters.ticket.quotes,
            managers: getters.ticket.managers,
            owners: getters.ticket.owners,
            tenants: getters.ticket.tenants,
            pb_type: getters.ticket.pb_type,
            fk_ticket_block: getters.ticket.fk_ticket_block,
            //fk_ticket_apartment: getters.ticket.fk_ticket_apartment,
            // New
            apartments: getters.ticket.apartments,
            participants: getters.ticket.participants,
            managers_assigned: getters.ticket.managers_assigned
          }));
        }
        return Promise.resolve(createdTicket);
      })
      .catch(error => {
        //commit(TICKET_INIT, state.service.initTicket());
        return Promise.reject(error);
      })
  },
  [TICKET_UPDATE] : async ({ commit, getters, state, rootGetters }, payload?: any ) => {
    const {
      id,
      subject,
      description,
      apartment_zone,
      equipments,
      fk_ticket_character_problem,
      fk_character_problem_level_2,
      pb_type, fk_ticket_priority, fk_ticket_substatus, mileage, availability } = getters.ticket

    return getters.service.updateTicket({
      id,
      subject,
      description,
      apartment_zone,
      equipments,
      fk_ticket_character_problem,
      fk_character_problem_level_2,
      pb_type,
      fk_ticket_priority,
      fk_ticket_substatus,
      mileage, availability
    })
    .then((updatedTicket: ITicket)=>{
      const data ={
              subject: updatedTicket.subject,
              description: updatedTicket.description,
              pb_type: updatedTicket.pb_type,
              apartment_zone: updatedTicket.apartment_zone,
              equipments: updatedTicket.equipments,
              fk_ticket_priority: updatedTicket.fk_ticket_priority,
              fk_ticket_substatus: updatedTicket.fk_ticket_substatus,
              fk_ticket_character_problem: updatedTicket.fk_ticket_character_problem,
              fk_character_problem_level_2: updatedTicket.fk_character_problem_level_2,
              ticket_availability_mileage:updatedTicket.ticket_availability_mileage
            }

      commit(TICKET_EDIT,data)
      commit(TICKET_INIT,state.service.initTicket())
      if(state.tickets && state.tickets.length) commit(TICKET_UPDATE_TICKETS, { ticketId: updatedTicket.id, data })
      return Promise.resolve(updatedTicket)
    })
    .catch(error=>{
      commit(TICKET_INIT,state.service.initTicket())
      return Promise.reject(error)
    })
  }
  , [TICKET_ACTION_SEND_MESSAGE]: async ({ commit, getters, state }, payload: { ticketId: string | number, channelId: string, message: string, createdAt: string }) => {
    return await getters.service.sendMessage(payload.ticketId, payload.channelId, payload.message, payload.createdAt)
      .then(response => response)
      .catch(error => {
        return Promise.reject(error)
      })
  }
  , [TICKET_ACTION_UPDATE_MESSAGE]: async ({ commit, getters, state }, payload: { ticketId: string | number, channelId: string, messageId: string, data: any }) => {
    return await getters.service.updateMessage(payload.ticketId, payload.channelId, payload.messageId, payload.data)
      .then(response => response)
      .catch(error => {
        return Promise.reject(error)
      })
  }
  , [TICKET_ACTION_DELETE_ATTACHMENT]: async ({ commit, getters, state }, payload: { ticketId: string | number, channelId: string, attachmentId: string, data: any }) => {
    return await getters.service.updateAttachment(payload.ticketId, payload.channelId, payload.attachmentId, payload.data)
      .then(response => response)
      .catch(error => {
        return Promise.reject(error)
      })
  }
  , [TICKET_ACTION_SEND_FILE]: async ({ commit, getters, state, rootGetters }, payload: { ticketId: string, channelId: string, data: any, creator: number, config?: any }) => {

    return await getters.service.sendFile(payload, payload.config)
      .then(result => {
        commit(TICKET_CLEAR_ATTACHMENTS, payload.data.fakeId);
        return { ...result, fakeId: payload.data.fakeId };
      })
      .catch(error => {
        return Promise.reject({
          loader_id: payload.data.loader_id,
          error: error.message,
          index: payload.data.index
        })
      })
  }
  , [TICKET_ACTION]: async ({ commit, getters, state }, payload: { actionName: string, reason: any, ticketId: string, data: any, textKey: string }) => {
    commit(TICKET_ACTION_LOADING, ActivityStatus.Loading)
    let promise: Promise<any>;
    if (payload.data) {
      promise = state.service[payload.actionName](payload.ticketId,
        payload.data.fk_actor_entity, payload.data.attachments,
        payload.textKey, payload.data[payload.textKey])
    } else if (payload.reason) {
      promise = state.service[payload.actionName](payload.ticketId, payload.reason);
    }
    else promise = state.service[payload.actionName](payload.ticketId);
    return await promise.then(response => {
      if (response.action_type === StateTypes.Close || response.action_type === StateTypes.ReOpen) {
        commit(TICKET_UPDATE_CURRENT_STATE, response.action_type)
      }
      commit(TICKET_ACTION_LOADING, ActivityStatus.Loaded);
      return Promise.resolve(response)
    })
      .catch(error => {
        commit(TICKET_ACTION_LOADING, ActivityStatus.LoadFailed);
        Promise.reject(error);
      })
  }
  , [TICKET_RECORD_CHANNEL]: async ({ commit, getters, state }, payload: { name: string, participants: any[] }) => {

    commit(TICKET_ACTION_LOADING, ActivityStatus.Loading)
    return await state.service.recordChannel(getters.currentTicket.id, payload.name, payload.participants)
      .then(response => {
        commit(TICKET_ACTION_LOADING, ActivityStatus.Loaded)
        return response;
      })
      .catch(error => {
        commit(TICKET_ACTION_LOADING, ActivityStatus.LoadFailed)
        return error;
      });
  }
  , [TICKET_RECORD_ASK_APPARTMENT]: async ({ commit, getters, state }, payload) => {

    commit(TICKET_ACTION_LOADING, ActivityStatus.Loading)

    return await state.service.recordAskAppointment(payload.ticketId, payload.startDate)
      .then(response => console.log(response))
      .catch(error => console.log(error))
  }
  , [TICKET_RESET]: ({ commit, state }) => {
    commit(TICKET_INIT, state.service.initTicket());
  }
  , [TICKET_REQUEST_TO_JOIN]: async ({ commit, state, rootGetters }, payload: { ticketId: string, channelId: string }) => {
    return await state.service.requestToJoin(payload.ticketId, rootGetters['user/userInfo'].id, payload.channelId)
  }
  , [TICKET_REQUEST_TO_JOIN_CHANNEL]: async ({ commit, state }, payload: { ticketId: string, channelId: string }) => {
    return await state.service.requestToJoinChannel(payload.ticketId, payload.channelId)
  }
  , [TICKET_GET_CHARACTER_PROBLEMS]: async ({ commit, state }) => {
    return await state.service.getCharacterProblems()
      .then(res => commit(TICKET_SET_CHARACTER_PROBLEMS, res))
      .catch(error => error)
  }
  , [TICKET_GET_EQUIPMENT]: async ({ commit, state }, params) => {
    return await state.service.getEquipments(params)
      .then(res => {
        commit(TICKET_SET_EQUIPMENT, res.data)
        return res
      })
      .catch(error => error)
  },
  [TICKET_GET_CLOSURE_REASON]: async ({ commit, state, rootGetters }, payload: { ticketId: string, channelId: string }) => {
    //if (state.ticketClosureReasons.length !== 0 && this.ticketClosureReasonsLoading !== ActivityStatus.Loading)
    if (state.ticketClosureReasons.length !== 0 && state.ticketClosureReasonsActivityStatus !== ActivityStatus.Loading)
      return;
    commit(TICKET_GET_CLOSURE_REASON_LOADING, ActivityStatus.Loading)
    return await state.service.getTicketClosureReason()
      .then(res => {
        commit(TICKET_GET_CLOSURE_REASON, res)
      })
      .catch(error => {
        commit(TICKET_GET_CLOSURE_REASON_LOADING, ActivityStatus.LoadFailed)
        return error;
      })
  },
  [TICKET_GET_REASONS]: async ({ commit, state, rootGetters }, payload: { ticketId: string, channelId: string }) => {
    //if (state.ticketClosureReasons.length !== 0 && this.ticketClosureReasonsLoading !== ActivityStatus.Loading)
    if (state.ticketReasons.length !== 0 && state.ticketReasonsActivityStatus !== ActivityStatus.Loading)
      return;
    commit(TICKET_GET_REASONS_LOADING, ActivityStatus.Loading)
    return await state.service.getTicketReason()
      .then(res => {
        commit(TICKET_GET_REASONS, res)
      })
      .catch(error => {
        commit(TICKET_GET_REASONS_LOADING, ActivityStatus.LoadFailed)
        return error;
      })
  },
  [TICKET_GET_TICKET_CHANNEL]: async ({ commit, state }, payload: { fk_action_channel: number, ticket_id: number }) => {
    await state.service!.getTicket(payload.ticket_id)
      .then(res => {
        commit(TICKET_SET_TICKET_CHANNEL, res)
      })
      .catch(err => {
        console.log(err, 'err');
      })
  },
  [TICKET_ADD_PARTICIPANTS]: async ({ commit, state }, payload: { ticketId: string, channelId: string, data: any[] }) => {
    return await state.service!.addParticipants(payload)
      .then(res => {
        return Promise.resolve(res)
      })
      .catch(error => {
        return Promise.reject(error)

      })
  },
  [TICKET_GET_CHANNEL]: async ({ commit, dispatch, state, rootGetters }, payload: { ticketId: number, channelId: number }) => {
    return await state.service.getTicketChannelById(payload.channelId, payload.ticketId)
      .then(channel => {
        commit(TICKET_SET_TICKET_ACTIONS, {
          currentChannel: channel,
          activityStatus: ActivityStatus.Loaded,
          currentTicketId: payload.ticketId,
          currentChannelId: payload.channelId,
          ownerId: rootGetters['user/userInfo'].id
        });

      })
      .catch(err => {
        console.log(err);

      })
  },
  [TICKET_REMOVE_PARTICIPANTS]: async ({ commit, dispatch, state }, payload: { ticketId: string, channelId: string, data: any[] }) => {
    return state.service!.removeParticipants(payload)
      .then(res => {

        return Promise.resolve(res)
      })
      .catch(error => {
        return Promise.reject(error)

      })
  }
  , [TICKET_GET_APPOINTMENTS]: async ({ commit, state }, ticketId: string) => {
    return await state.service!.getTicketAppointments(ticketId)
      .then(res => {
        commit(TICKET_GET_APPOINTMENTS, res)
        return Promise.resolve(res)
      })
      .catch(err => {
        commit(TICKET_GET_APPOINTMENTS, [])
        return Promise.reject(err)
      })
  }
  , [TICKET_INTERVENTION_REPORT]: async ({ state, commit }, payload: { ticketId: string, data: ITicketInterventionReport }) => {
    return await state.service.sendInterventionReport(payload.ticketId, payload.data)
  }
  , [TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS]: async ({ getters, state, commit }, ticketId: number) => {
    if (state.currentTicket && ticketId === state.currentTicket.id) {
      commit(TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS, state.currentTicket)
      return;
    }

    commit(TICKET_LOADING, ActivityStatus.Loading);
    return await getters.service!.getTicket(ticketId)
      .then((ticket: ITicket) => {
        commit(TICKET_GET_TICKET_INDEPENDENT_CONTRACTORS, ticket)
        commit(TICKET_LOADING, ActivityStatus.Loaded);
      })
      .catch(error => {
        commit(TICKET_LOADING, ActivityStatus.LoadFailed);
        return Promise.reject(error);
      })
  },
  [TICKET_GET_TICKET_PRIORITY_LEVEL]: async ({ commit, state }) => {
    return await state.service.getTicketPriorityLevels()
      .then(res => commit(TICKET_SET_TICKET_PRIORITY_LEVEL, res))
      .catch(error => error)
  },
  [TICKET_GET_TICKET_SUBSTATUS]: async ({ commit, state }) => {
    return await state.service.getTicketSubstatus()
      .then(res => commit(TICKET_SET_TICKET_SUBSTATUS, res))
      .catch(error => error)
  },
  [TICKET_GET_TICKET_PROBLEM_TYPE]: async ({ commit, state }) => {
    return await state.service.getTicketProblemType()
      .then(res => commit(TICKET_SET_TICKET_PROBLEM_TYPE, res))
      .catch(error => error)
  }
}



// WEBPACK FOOTER //
// ./src/store/ticket/ticket-actions.store.ts